<template>
  <div :id='id' class="dropdown-container">
    <div class="dropdown width_full">
      <input
        id="searchBox"
        class="grid-12"
        v-model="filterText"
        type="text"
        :placeholder='placeHolder'
        @click="show = !show"
        @keyup="checkInput"
        @keydown="show = true"
        >
      </input>
      <div v-if="screenName === 'ItemLevel'">
        <div id="myDropdown" class="dropdown-content" v-if="">
          <ul class='grid-12'>
            <li @click="dropdownItemClick($event, data)" v-for="data in modifiedList">{{ data.name }}</li>
          </ul>
        </div>
      </div>
      <div else>
        <div id="myDropdown" class="dropdown-content" v-if="show && screenName !== 'ItemLevel'">
          <ul class='grid-12'>
            <li @click="dropdownItemClick($event, data)" v-for="data in modifiedList">{{ data.name }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { filter } from 'lodash'
import { CLEAR_FILTER } from 'src/constants/Constants'
// import { cloneDeep } from 'lodash'

export default {
  data () {
    return {
      show: false,
      filterText: null,
      itemSelected: null
    }
  },
  props: {
    'list': {
      required: true
    },
    'id': {
      required: true
    },
    'defaultValue': {
      required: false
    },
    'reset': {
      required: false
    },
    'selectedItem': {
      required: false
    },
    'screenName': {
      required: false
    }
  },
  created () {
    this.clearFilters()
    window.eventBus.$on('strayClick', (e) => {
      if (!this.isDescendant(document.getElementById(this.id), e.target)) this.show = false
    })
  },
  beforeUpdate () {
    this.clearFilters()
  },
  methods: {
    setFocus () {
      // document.getElementById('searchBox').focus()
    },
    dropdownItemClick (e, item) {
      this.itemSelected = item
      this.show = false
      this.filterText = (item === '(none)') ? null : item.name
      this.$emit('input', item)
    },
    checkInput (e) {
      // console.log(this.filterText)
      if (!this.filterText || !this.filterText.trim()) {
        this.$emit('input', CLEAR_FILTER)
      } else {
        let copy = {}
        // console.log(this.filterText, copy)
        if (copy && this.filterText) {
          copy.name = this.filterText
        } else {
          copy = {}
          copy.name = this.filterText
        }
        this.$emit('input', copy)
      }
    },
    clearFilters () {

    },
    isDescendant (parent, child) {
      var node = child.parentNode
      while (node !== null) {
        if (node === parent) {
          return true
        }
        node = node.parentNode
      }
      return false
    },
    filterItems (query) {
      let data = this.originalList.filter((el) => {
        if (el && el.name) {
          return el.name.toLowerCase().indexOf(query.toLowerCase()) > -1
        }
      })
      return data
    }
  },
  mounted () {
    this.setFocus()
  },
  computed: {
    originalList () {
      return this.list
    },
    modifiedList () {
      this.setFocus()
      if (this.filterText) {
        return this.filterItems(this.filterText)
      }
      return this.originalList
    },
    placeHolder () {
      if (this.screenName !== 'ItemLevel') {
        this.filterText = this.selectedItem
      }
      return 'Search'
    }
  }
}
</script>

<style scoped>

.dropdown-container {
  position: relative;
}

@media only screen and (min-width: 100px) {
  .dropdown {
    display: inline-block;
    min-width: 100%;
  }
}

@media only screen and (min-width: 1000px) {
  .dropdown {
    display: inline-block;
    min-width: 16rem;
  }
}

.dropdown.grid-4 {
  padding: 0;
}

input {
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  border-radius:.3rem;
  padding: 1rem;
  background-color: white;
}

.dropdown-content {
  display: block;
  margin-top: 4rem;
}

.dropdown-content ul {
  background-color: #f9f9f9;
  overflow-y: auto;
  max-height: 35rem;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 0;
  margin: 0;
  text-align: center;
  position: absolute;
  z-index: 5;
}

.dropdown-content li {
  color: black;
  font-size: 1.2rem;
  padding: 1rem 1.2rem;
  text-decoration: none;
  display: block;
}

.dropdown li:hover {
  background-color: #f1f1f1
}

.show {
  display:block;
}

</style>



// WEBPACK FOOTER //
// SearchableDropDown.vue?c87382ea